import { call, put, select, takeEvery } from 'redux-saga/effects'
import { STORIES, STORIES_GET_PROTRACKS, STORIES_LOAD_MORE, STORIES_SCROLL } from 'store/entities/stories/actionTypes'
import {
  getStoriesLoadMoreLoaded,
  getStoriesLoadMorePending,
  getStoriesPagination,
  getStoriesPending,
  getStoriesProTrackId,
} from 'store/entities/stories/selectors'
import {
  enableStoriesGetPending,
  enableStoriesLoadMorePending,
  proTrackList,
  storiesList,
  storiesLoadMore,
} from 'store/entities/stories/actions'
import makeAPIRequest from 'store/entities/api/sagas'
import { GET_STORIES } from 'app/constants/api/feed'
import { STORIES_PROTRACK_FILTER_DEFAULT_ID } from 'app/constants/stories'

export default function* getStoriesSaga() {
  yield* [
    takeEvery(STORIES_GET_PROTRACKS.GET.REQUEST, handleLoadProTracks),
    takeEvery(STORIES.GET.REQUEST, handleGetStories),
    takeEvery(STORIES_LOAD_MORE.GET.REQUEST, handleGetLoadMoreStories),
    takeEvery(STORIES_SCROLL, handleStoriesScroll),
  ]
}

export function* handleLoadProTracks() {
  // eslint-disable-next-line no-useless-catch
  try {
    // eslint-disable-line no-useless-catch
    const { data } = yield call(makeAPIRequest, `${GET_STORIES}/protracks`, {
      method: 'GET',
    })
    yield put(proTrackList.get.success(data))
  } catch (badResponse) {
    throw badResponse
  }
}

export function* handleGetStories() {
  const pending = yield select(getStoriesPending)
  if (!pending) {
    yield put(enableStoriesGetPending)
    const data = yield makeGetStoriesRequest()
    yield put(storiesList.get.success(data))
  }
}

export function* handleGetLoadMoreStories() {
  const pending = yield select(getStoriesLoadMorePending)
  if (!pending) {
    yield put(enableStoriesLoadMorePending)
    const data = yield makeGetStoriesRequest(true)
    yield put(storiesLoadMore.get.success(data))
  }
}

export function* makeGetStoriesRequest(isNext = false) {
  // eslint-disable-next-line no-useless-catch
  try {
    // eslint-disable-line no-useless-catch
    const storiesPagination = yield select(getStoriesPagination)
    const storiesProTrackId = yield select(getStoriesProTrackId)
    const page = storiesPagination.get('page') + isNext
    const limit = storiesPagination.get('limit')
    const proTrack = storiesProTrackId === STORIES_PROTRACK_FILTER_DEFAULT_ID ? '' : `&protrack=${storiesProTrackId}`
    const { data } = yield call(
      makeAPIRequest,
      `${GET_STORIES}/stories?page=${page}&limit=${limit}&sort=createdAt&desc=1${proTrack}`,
      {
        method: 'GET',
      }
    )
    return data
  } catch (badResponse) {
    throw badResponse
  }
}

export function* handleStoriesScroll({ payload: { scrollTop, clientHeight, scrollHeight } }) {
  const loaded = yield select(getStoriesLoadMoreLoaded)
  if (!loaded && scrollTop + clientHeight >= scrollHeight) {
    yield put(storiesLoadMore.get.request())
  }
}
